import { render } from "./Error404.vue?vue&type=template&id=bb661f2c&scoped=true"
const script = {}

import "./Error404.vue?vue&type=style&index=0&id=bb661f2c&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb661f2c"]])

export default __exports__